import { catchError } from "../../../Actions/Error.action";

export const NEWS_PAGE_RECEIVE = "NEWS_PAGE_RECEIVE";
export const NEWS_PAGE_ERROR = 'NEWS_PAGE_ERROR';
export const NEWS_PAGE_CHANGE_CURRENTPAGE = "NEWS_PAGE_CHANGE_CURRENTPAGE";
export const NEWS_PAGE_RECEIVE_NEWS_LIST = "NEWS_PAGE_RECEIVE_NEWS_LIST";
export const NEWS_PAGE_RECEIVE_TOTAL_COUNT = "NEWS_PAGE_RECEIVE_TOTAL_COUNT";

export const fetchNewsPageData = (id, pageIndex, pageSize) => async (dispatch) => {
    try {
        const html = document.querySelector("html");
        const culture = html.getAttribute("lang");
        const response = await fetch(`/api/newsPage?id=${id}&lang=${culture}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
        if (!response.ok) {
            throw new Error('Failed to fetch news page data');
        }
        const result = await response.json();
        dispatch(receiveNewsList(result.newsList)); 
        dispatch(receiveTotalCount(result.totalCount));
        dispatch(changeCurrentPage(pageIndex));
    } catch (error) {
        dispatch(catchError(error, setError));
    }
};

export const receiveNewsList = newsList => ({
    type: NEWS_PAGE_RECEIVE_NEWS_LIST,
    payload: newsList
});

export const receiveTotalCount = totalCount => ({
    type: NEWS_PAGE_RECEIVE_TOTAL_COUNT,
    payload: totalCount
});

export const setError = error => ({
    type: NEWS_PAGE_ERROR,
    payload: {
        error,
    },
});

export const changeCurrentPage = (currentPage) => ({
    type: NEWS_PAGE_CHANGE_CURRENTPAGE,
    payload: {
        currentPage,
    },
});
